module.exports = __webpack_public_path__ + "img/changsha01.995fc553.png";